export const COLLECT_COUPON = "COLLECT_COUPON";
export const DISPLAY_COUPON_POPUP = "DISPLAY_COUPON_POPUP";
export const GET_COUPONS = "GET_COUPONS";
export const STORE_COUPON = "STORE_COUPON";
export const GET_COUPON_URL = "GET_COUPON_URL";
export const GET_COUPON_USAGE = "GET_COUPON_USAGE";
export const DISPLAY_COUPON_LIST_POPUP = "DISPLAY_COUPON_LIST_POPUP";
export const GET_USER_COUPONS = "GET_USER_COUPONS";
export const GET_USABLE_COUPONS = "GET_USABLE_COUPONS";